import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { MdPreview } from "md-editor-v3";

/**
 * 定义组件属性类型
 */
interface Props {
  value: string;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'MdViewer',
  props: {
    value: { default: () => "" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MdPreview), {
    editorId: 'preview-only',
    modelValue: _ctx.value
  }, null, 8, ["modelValue"]))
}
}

})